export const Screens = {
  EMPTY_STATE: 'emptyState',
  EMPTY_ADS: 'emptyAds',
  WITH_ONE_DRAFT: 'withOneDraft',
};
